<h1 matDialogTitle>Invoice Lines - {{data?.erpSalesOrderNumber}}</h1>

<mat-dialog-content>
  <div style="width: 100%">
    <kendo-grid *ngIf="lines" [kendoGridBinding]="lines" [scrollable]="true" [resizable]="true"
      [reorderable]="true" [sortable]="true" [selectable]="true" kendoGridSelectBy="lineNumber"
      [(selectedKeys)]="selectedLines">

      <kendo-grid-checkbox-column [locked]="true" [width]="70"></kendo-grid-checkbox-column>

      <kendo-grid-column [locked]="true" [width]="140" field="displayCode" title="Code">
      </kendo-grid-column>

      <kendo-grid-column [width]="420" title="Description">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <span class="ellipse">{{dataItem.lineDescription2 ? dataItem.lineDescription + ' - ' + dataItem.lineDescription2 :dataItem.lineDescription}}</span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column [width]="100" field="warehouseCode" title="Warehouse"> </kendo-grid-column>

      <kendo-grid-column [width]="200" field="deliveryMethod" title="Del. Method">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <span class="ellipse">{{dataItem.deliveryMethod}}</span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column [width]="100" field="orderQty" format="{0:n0}" class="td-number" title="Order Qty">
      </kendo-grid-column>

      <kendo-grid-column [width]="100" field="shipQty" format="{0:n0}" class="td-number" title="Ship Qty">
      </kendo-grid-column>

      <kendo-grid-column [width]="100" field="backOrderQty" format="{0:n0}" class="td-number" title="BO Qty">
      </kendo-grid-column>

      <kendo-grid-column [width]="130" format="{0:n2}" class="td-number" field="lineTotalAmount"
        title="Line Amt.">
      </kendo-grid-column>


    </kendo-grid>
  </div>
  <!-- <pre>{{selectedLines | json}}</pre>
  <pre>{{selectedLines.join(',')}}</pre> -->
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button matDialogClose>Cancel</button>
    <button mat-button [disabled]="!selectedLines || selectedLines.length === 0" (click)="createInvoice()" >Create Invoice</button>
</mat-dialog-actions>
